import { History } from "history";

import {
  CreateGovernorateRequest,
  GovernorateDto,
  PaginateQuery,
  UpdateGovernorateRequest,
} from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";

//#region Get Governorates

export const GET_GOVERNORATES = "GET_GOVERNORATES";
export const GET_GOVERNORATES_SUCCESS: any = "GET_GOVERNORATES_SUCCESS";
export const GET_GOVERNORATES_ERROR: any = "GET_GOVERNORATES_ERROR";

export interface GetGovernoratesAction {
  type: typeof GET_GOVERNORATES;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetGovernoratesSuccessAction {
  type: typeof GET_GOVERNORATES_SUCCESS;
  payload: Paginated<GovernorateDto>;
}

export interface GetGovernoratesErrorAction {
  type: typeof GET_GOVERNORATES_ERROR;
  payload: any;
}
//#endregion

//#region Get Governorate

export const GET_GOVERNORATE = "GET_GOVERNORATE";
export const GET_GOVERNORATE_SUCCESS: any = "GET_GOVERNORATE_SUCCESS";
export const GET_GOVERNORATE_ERROR: any = "GET_GOVERNORATE_ERROR";

export interface GetGovernorateAction {
  type: typeof GET_GOVERNORATE;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetGovernorateSuccessAction {
  type: typeof GET_GOVERNORATE_SUCCESS;
  payload: GovernorateDto;
}

export interface GetGovernorateErrorAction {
  type: typeof GET_GOVERNORATE_ERROR;
  payload: any;
}
//#endregion

//#region Get Governorate Select List

export const GET_GOVERNORATE_SELECT_LIST = "GET_GOVERNORATE_SELECT_LIST";
export const GET_GOVERNORATE_SELECT_LIST_SUCCESS: any =
  "GET_GOVERNORATE_SELECT_LIST_SUCCESS";
export const GET_GOVERNORATE_SELECT_LIST_ERROR: any =
  "GET_GOVERNORATE_SELECT_LIST_ERROR";

export interface GetGovernorateSelectListAction {
  type: typeof GET_GOVERNORATE_SELECT_LIST;
  payload: {
    history: History;
  };
}

export interface GetGovernorateSelectListSuccessAction {
  type: typeof GET_GOVERNORATE_SELECT_LIST_SUCCESS;
  payload: SelectListDto[];
}

export interface GetGovernorateSelectListErrorAction {
  type: typeof GET_GOVERNORATE_SELECT_LIST_ERROR;
  payload: any;
}
//#endregion

//#region Add Governorate

export const ADD_GOVERNORATE = "ADD_GOVERNORATE";
export const ADD_GOVERNORATE_SUCCESS: any = "ADD_GOVERNORATE_SUCCESS";
export const ADD_GOVERNORATE_ERROR: any = "ADD_GOVERNORATE_ERROR";

export interface AddGovernorateAction {
  type: typeof ADD_GOVERNORATE;
  payload: {
    request: CreateGovernorateRequest;
    history: History;
  };
}

export interface AddGovernorateSuccessAction {
  type: typeof ADD_GOVERNORATE_SUCCESS;
  payload: null;
}

export interface AddGovernorateErrorAction {
  type: typeof ADD_GOVERNORATE_ERROR;
  payload: any;
}
//#endregion

//#region Update Governorate

export const UPDATE_GOVERNORATE = "UPDATE_GOVERNORATE";
export const UPDATE_GOVERNORATE_SUCCESS: any = "UPDATE_GOVERNORATE_SUCCESS";
export const UPDATE_GOVERNORATE_ERROR: any = "UPDATE_GOVERNORATE_ERROR";

export interface UpdateGovernorateAction {
  type: typeof UPDATE_GOVERNORATE;
  payload: {
    id: string;
    request: UpdateGovernorateRequest;
    history: History;
  };
}

export interface UpdateGovernorateSuccessAction {
  type: typeof UPDATE_GOVERNORATE_SUCCESS;
  payload: null;
}

export interface UpdateGovernorateErrorAction {
  type: typeof UPDATE_GOVERNORATE_ERROR;
  payload: any;
}
//#endregion

//#region Delete Governorate

export const DELETE_GOVERNORATE_CONSENT: any = "DELETE_GOVERNORATE_CONSENT";
export const DELETE_GOVERNORATE = "DELETE_GOVERNORATE";
export const DELETE_GOVERNORATE_SUCCESS: any = "DELETE_GOVERNORATE_SUCCESS";
export const DELETE_GOVERNORATE_ERROR: any = "DELETE_GOVERNORATE_ERROR";

export interface DeleteGovernorateConsentAction {
  type: typeof DELETE_GOVERNORATE_CONSENT;
  payload: string;
}

export interface DeleteGovernorateAction {
  type: typeof DELETE_GOVERNORATE;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteGovernorateSuccessAction {
  type: typeof DELETE_GOVERNORATE_SUCCESS;
  payload: null;
}

export interface DeleteGovernorateErrorAction {
  type: typeof DELETE_GOVERNORATE_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetGovernoratesAction
  | GetGovernoratesSuccessAction
  | GetGovernoratesErrorAction
  | GetGovernorateAction
  | GetGovernorateSuccessAction
  | GetGovernorateErrorAction
  | GetGovernorateSelectListAction
  | GetGovernorateSelectListSuccessAction
  | GetGovernorateSelectListErrorAction
  | AddGovernorateAction
  | AddGovernorateSuccessAction
  | AddGovernorateErrorAction
  | UpdateGovernorateAction
  | UpdateGovernorateSuccessAction
  | UpdateGovernorateErrorAction
  | DeleteGovernorateConsentAction
  | DeleteGovernorateAction
  | DeleteGovernorateSuccessAction
  | DeleteGovernorateErrorAction;
